import { createAsyncThunk } from "@reduxjs/toolkit";

import {
getAdminBranches,
createAdminBranch,
updateAdminBranch,
deleteAdminBranch,
} from "../../api/admin/branches.api";

/* ================= FETCH ================= */

export const fetchBranches = createAsyncThunk(
"admin/branches/fetch",
async (
{ page = 1, limit = 10, search = "" },
{ rejectWithValue }
) => {
const res = await getAdminBranches({
page,
limit,
search,
});


if (!res.success) {
  return rejectWithValue(res.message);
}

return res;


}
);

/* ================= CREATE ================= */

export const addBranch = createAsyncThunk(
"admin/branches/add",
async (payload, { rejectWithValue }) => {


console.log(
  "📡 ADD BRANCH API CALL PAYLOAD:",
  payload
);

const res = await createAdminBranch(payload);

console.log(
  "📥 ADD BRANCH API RESPONSE:",
  res
);

if (!res.success) {
  return rejectWithValue(res.message);
}

return res;


}
);

/* ================= UPDATE ================= */

export const updateBranch = createAsyncThunk(
"admin/branches/update",
async (
{ id, branchData },
{ rejectWithValue }
) => {


const res = await updateAdminBranch(
  id,
  branchData
);

if (!res.success) {
  return rejectWithValue(res.message);
}

return res;


}
);

/* ================= DELETE ================= */

export const deleteBranch = createAsyncThunk(
"admin/branches/delete",
async (
id,
{ rejectWithValue }
) => {


const res = await deleteAdminBranch(id);

if (!res.success) {
  return rejectWithValue(res.message);
}

return { id };


}
);
